import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom'; // useParams ve Link import edildi
import { useAuth } from './AuthContext'; // user.id için AuthContext'i kullanıyoruz
import InvoiceAdd from './InvoiceAdd'; // İrsaliye Ekle formu
import PaymentAdd from './PaymentAdd'; // Ödeme Ekle formu
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

function CustomerDetailPage() {
  const { id } = useParams(); // URL'den müşteri ID'sini alırız (örneğin /customer/123 -> id = 123)
  const { user } = useAuth(); // Mevcut kullanıcının bilgilerini al
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0); // Verileri yenilemek için bir tetikleyici

  // Modal durumları
  const [showInvoiceAddModal, setShowInvoiceAddModal] = useState(false);
  const [showInvoiceEditModal, setShowInvoiceEditModal] = useState(false);
  const [editingInvoiceData, setEditingInvoiceData] = useState(null);
  const [showPaymentAddModal, setShowPaymentAddModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentInvoicePage, setCurrentInvoicePage] = useState(1); // Yeni: İrsaliyeler için mevcut sayfa
  const [currentPaymentPage, setCurrentPaymentPage] = useState(1); // Yeni: Ödemeler için mevcut sayfa
  const itemsPerPage = 5; // Yeni: Sayfa başına kayıt sayısı

  const navigate = useNavigate();

  // Esc tuşu ile modal kapatma
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setShowInvoiceAddModal(false);
        setShowPaymentAddModal(false);
        if (showInvoiceEditModal) setShowInvoiceEditModal(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [showInvoiceEditModal]);

  useEffect(() => {
    if (!user || !id) return;
    console.log("customer_id:", id, "user_id:", user ? user.id : null);
    setLoading(true);
    setError(null);
    // user ID'si ile birlikte müşteri detaylarını çek ve sayfalama parametrelerini gönder
    fetch(`https://www.irsaliye.bybello.com/backend/api/customer_detail.php?customer_id=${id}&user_id=${user ? user.id : ''}&invoice_page=${currentInvoicePage}&invoice_limit=${itemsPerPage}&payment_page=${currentPaymentPage}&payment_limit=${itemsPerPage}`, {
      credentials: 'include',
    })
      .then(res => {
        if (!res.ok) {
          throw new Error('Müşteri detayları çekilemedi veya yetkiniz yok.');
        }
        return res.json();
      })
      .then(data => {
        setCustomerData(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Müşteri detayları çekilirken hata:", err);
        setError(err.message);
        setLoading(false);
      });
  }, [id, refreshKey, user, currentInvoicePage, currentPaymentPage]); // Bağımlılıkları güncellendi

  const handleRefreshData = () => {
    setRefreshKey(prevKey => prevKey + 1); // Verileri yeniden çekmek için anahtarı artır
    setShowInvoiceAddModal(false); // Modalları kapat
    setShowPaymentAddModal(false);
  };

  const handleDeleteInvoice = (invoiceId) => {
    if (window.confirm("Bu irsaliyeyi silmek istediğinizden emin misiniz?")) {
      fetch('https://www.irsaliye.bybello.com/backend/api/invoices.php', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `id=${invoiceId}`
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            alert("İrsaliye başarıyla silindi.");
            handleRefreshData(); // Sayfayı yenile
          } else {
            alert(data.error || "İrsaliye silme başarısız.");
          }
        })
        .catch(err => alert("İrsaliye silme sırasında ağ hatası: " + err.message));
    }
  };

  const handleDeletePayment = (paymentId) => {
    if (window.confirm("Bu ödemeyi silmek istediğinizden emin misiniz?")) {
      fetch('https://www.irsaliye.bybello.com/backend/api/payments.php', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `id=${paymentId}`
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            alert("Ödeme başarıyla silindi.");
            handleRefreshData(); // Sayfayı yenile
          } else {
            alert(data.error || "Ödeme silme başarısız.");
          }
        })
        .catch(err => alert("Ödeme silme sırasında ağ hatası: " + err.message));
    }
  };

  const handleExportExcel = () => {
    if (!filteredInvoices || filteredInvoices.length === 0) {
      alert('Aktarılacak irsaliye yok!');
      return;
    }
    // Excel için uygun veri formatı
    const data = filteredInvoices.map(inv => ({
      'İrsaliye No': inv.invoice_number,
      'Tarih': inv.date,
      'Ürün': inv.items && inv.items.map(item => item.product_name).join(', '),
      'Açıklama': inv.items && inv.items.map(item => item.description).filter(desc => desc).join(', '),
      'Tutar': inv.total_price
    }));
    // Toplam tutarı hesapla
    const total = filteredInvoices.reduce((sum, inv) => sum + Number(inv.total_price), 0);
    // Son satıra toplamı ekle
    data.push({ 'İrsaliye No': '', 'Tarih': '', 'Ürün': '', 'Açıklama': 'Toplam', 'Tutar': total });
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Sütun genişliklerini ayarla
    worksheet['!cols'] = [
      { wch: 12 }, // İrsaliye No
      { wch: 12 }, // Tarih
      { wch: 20 }, // Ürün
      { wch: 20 }, // Açıklama
      { wch: 12 }  // Tutar
    ];

    // Başlık satırını kalın yap
    const header = ['A1','B1','C1','D1','E1'];
    header.forEach(cell => {
      if (worksheet[cell]) {
        worksheet[cell].s = {
          font: { bold: true, sz: 12 },
          alignment: { horizontal: 'center' }
        };
      }
    });

    // Toplam satırını kalın ve açık sarı yap
    const totalRow = data.length + 1; // 1-based
    const totalLabelCell = `D${totalRow}`;
    const totalValueCell = `E${totalRow}`;
    if (worksheet[totalLabelCell]) {
      worksheet[totalLabelCell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: 'FFF9C4' } },
        alignment: { horizontal: 'right' }
      };
    }
    if (worksheet[totalValueCell]) {
      worksheet[totalValueCell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: 'FFF9C4' } },
        alignment: { horizontal: 'right' }
      };
    }

    // Tutar ve Tarih sütunlarını biçimlendir
    for (let row = 2; row <= data.length + 1; row++) {
      const amountCell = `E${row}`;
      if (worksheet[amountCell]) {
        worksheet[amountCell].z = '₺ #,##0.00';
        // Toplam satırı hariç, tüm değerleri number olarak yaz
        if (row !== data.length + 1 && typeof worksheet[amountCell].v === 'string') {
          worksheet[amountCell].v = Number(worksheet[amountCell].v);
        }
      }
      const dateCell = `B${row}`;
      if (worksheet[dateCell] && worksheet[dateCell].v) {
        worksheet[dateCell].z = 'yyyy-mm-dd';
        // Tarih stringini Excel'in tarih formatına çevir
        const dateValue = worksheet[dateCell].v;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
          const [y, m, d] = dateValue.split('-').map(Number);
          worksheet[dateCell].v = new Date(Date.UTC(y, m - 1, d));
          worksheet[dateCell].t = 'd';
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'İrsaliyeler');
    XLSX.writeFile(workbook, `irsaliyeler_${customer.name}.xlsx`);
  };

  // Ödemeleri Excel'e aktar
  const handleExportPaymentsExcel = () => {
    if (!payments || payments.length === 0) {
      alert('Aktarılacak ödeme yok!');
      return;
    }
    const data = payments.map(pay => ({
      'Tarih': pay.date,
      'Tutar': pay.amount
    }));
    const total = payments.reduce((sum, pay) => sum + Number(pay.amount), 0);
    data.push({ 'Tarih': 'Toplam', 'Tutar': total });
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet['!cols'] = [
      { wch: 12 }, // Tarih
      { wch: 12 }  // Tutar
    ];
    // Başlık satırını kalın yap
    ['A1','B1'].forEach(cell => {
      if (worksheet[cell]) {
        worksheet[cell].s = {
          font: { bold: true, sz: 12 },
          alignment: { horizontal: 'center' }
        };
      }
    });
    // Toplam satırını kalın ve açık sarı yap
    const totalRow = data.length + 1;
    const totalLabelCell = `A${totalRow}`;
    const totalValueCell = `B${totalRow}`;
    if (worksheet[totalLabelCell]) {
      worksheet[totalLabelCell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: 'FFF9C4' } },
        alignment: { horizontal: 'right' }
      };
    }
    if (worksheet[totalValueCell]) {
      worksheet[totalValueCell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: 'FFF9C4' } },
        alignment: { horizontal: 'right' }
      };
    }
    // Tutar ve Tarih sütunlarını biçimlendir
    for (let row = 2; row <= data.length + 1; row++) {
      const amountCell = `B${row}`;
      const dateCell = `A${row}`;
      if (worksheet[dateCell] && worksheet[dateCell].v && worksheet[dateCell].v !== 'Toplam') {
        worksheet[dateCell].z = 'yyyy-mm-dd';
        const dateValue = worksheet[dateCell].v;
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
          const [y, m, d] = dateValue.split('-').map(Number);
          worksheet[dateCell].v = new Date(Date.UTC(y, m - 1, d));
          worksheet[dateCell].t = 'd';
        }
      }
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Ödemeler');
    XLSX.writeFile(workbook, `odemeler_${customer.name}.xlsx`);
  };

  // PDF'e aktarım fonksiyonu
  const handleExportPDF = () => {
    if (!filteredInvoices || filteredInvoices.length === 0 || !customer) {
      alert('Aktarılacak irsaliye yok!');
      return;
    }
    const doc = new jsPDF();
    const tableColumn = ['İrsaliye No', 'Tarih', 'Ürün', 'Açıklama', 'Tutar'];
    const tableRows = filteredInvoices.map(inv => [
      inv.invoice_number,
      inv.date,
      inv.items && inv.items.map(item => item.product_name).join(', '),
      inv.items && inv.items.map(item => item.description).filter(desc => desc).join(', '),
      Number(inv.total_price).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })
    ]);
    // Toplam satırı ekle
    const total = filteredInvoices.reduce((sum, inv) => sum + Number(inv.total_price), 0);
    tableRows.push(['', '', '', 'Toplam', total.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })]);
    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save(`irsaliyeler_${customer.name}.pdf`);
  };

  // Tüm irsaliyeleri yeni sekmede açan fonksiyon (tüm sayfalardan çeker)
  const handleOpenAllInvoicesInNewTab = async () => {
    if (!customer) {
      alert('Listelenecek irsaliye yok!');
      return;
    }
    // API'den tüm irsaliyeleri çek
    let allInvoices = [];
    try {
      const res = await fetch(`https://www.irsaliye.bybello.com/backend/api/customer_detail.php?customer_id=${customer.id}&user_id=${user.id}&invoice_limit=10000&invoice_page=1`, { credentials: 'include' });
      if (!res.ok) throw new Error('Tüm irsaliyeler alınamadı!');
      const data = await res.json();
      allInvoices = data.invoices || [];
    } catch (err) {
      alert('Tüm irsaliyeler alınamadı!');
      return;
    }
    if (allInvoices.length === 0) {
      alert('Listelenecek irsaliye yok!');
      return;
    }
    let total = allInvoices.reduce((sum, inv) => sum + Number(inv.total_price), 0);
    let html = `
      <html>
      <head>
        <title>${customer.name} - Tüm İrsaliyeler</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 40px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
          th { background: #f5f5f5; }
        </style>
      </head>
      <body>
        <h2>${customer.name} - Tüm İrsaliyeler</h2>
        <table>
          <thead>
            <tr>
              <th>İrsaliye No</th>
              <th>Tarih</th>
              <th>Ürün</th>
              <th>Açıklama</th>
              <th>Tutar</th>
            </tr>
          </thead>
          <tbody>
            ${allInvoices.map(inv => `
              <tr>
                <td>${inv.invoice_number}</td>
                <td>${inv.date}</td>
                <td>${inv.items && inv.items.map(item => item.product_name).join(', ')}</td>
                <td>${inv.items && inv.items.map(item => item.description).filter(desc => desc).join(', ')}</td>
                <td>${Number(inv.total_price).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
              </tr>
            `).join('')}
            <tr>
              <td colspan="4" style="text-align:right;font-weight:bold;">Toplam</td>
              <td style="font-weight:bold;">${total.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
            </tr>
          </tbody>
        </table>
      </body>
      </html>
    `;
    const newWindow = window.open();
    newWindow.document.write(html);
    newWindow.document.close();
  };

  // Tüm ödemeleri yeni sekmede açan fonksiyon (tüm sayfalardan çeker)
  const handleOpenAllPaymentsInNewTab = async () => {
    if (!customer) {
      alert('Listelenecek ödeme yok!');
      return;
    }
    // API'den tüm ödemeleri çek
    let allPayments = [];
    try {
      const res = await fetch(`https://www.irsaliye.bybello.com/backend/api/customer_detail.php?customer_id=${customer.id}&user_id=${user.id}&payment_limit=10000&payment_page=1`, { credentials: 'include' });
      if (!res.ok) throw new Error('Tüm ödemeler alınamadı!');
      const data = await res.json();
      allPayments = data.payments || [];
    } catch (err) {
      alert('Tüm ödemeler alınamadı!');
      return;
    }
    if (allPayments.length === 0) {
      alert('Listelenecek ödeme yok!');
      return;
    }
    let total = allPayments.reduce((sum, pay) => sum + Number(pay.amount), 0);
    let html = `
      <html>
      <head>
        <title>${customer.name} - Tüm Ödemeler</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 40px; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
          th { background: #f5f5f5; }
        </style>
      </head>
      <body>
        <h2>${customer.name} - Tüm Ödemeler</h2>
        <table>
          <thead>
            <tr>
              <th>Tarih</th>
              <th>Tutar</th>
            </tr>
          </thead>
          <tbody>
            ${allPayments.map(pay => `
              <tr>
                <td>${pay.date}</td>
                <td>${Number(pay.amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
              </tr>
            `).join('')}
            <tr>
              <td style="text-align:right;font-weight:bold;">Toplam</td>
              <td style="font-weight:bold;">${total.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
            </tr>
          </tbody>
        </table>
      </body>
      </html>
    `;
    const newWindow = window.open();
    newWindow.document.write(html);
    newWindow.document.close();
  };

  if (loading) return <div className="container mt-4">Yükleniyor...</div>;
  if (error) return <div className="container mt-4 alert alert-danger">{error}</div>;
  if (!customerData || !customerData.customer) return <div className="container mt-4 alert alert-warning">Müşteri bilgisi bulunamadı. Lütfen kontrol edin.</div>;

  const { customer, invoices, payments, balance, total_invoices_count, total_payments_count } = customerData;

  // Sayfa hesaplamaları
  const totalInvoicePages = Math.ceil(total_invoices_count / itemsPerPage);
  const totalPaymentPages = Math.ceil(total_payments_count / itemsPerPage);

  // Arama sorgusuna göre irsaliyeleri filtrele
  const filteredInvoices = invoices.filter(inv => {
    if (searchQuery === '') {
      return true; // Arama boşsa tüm irsaliyeleri göster
    }
    // Her bir irsaliyenin ürün kalemlerinin açıklamalarında arama yap
    return inv.items.some(item => 
      item.description && item.description.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Müşteri Detayları: {customer.name}</h1>
        <Link to="/dashboard" className="btn btn-primary">Ana Sayfaya Dön</Link>
      </div>

      <div className="card mb-4">
        <div className="card-header" style={{ fontSize: '1.25rem', fontWeight: 600 }}>Müşteri Bilgileri</div>
        <div className="card-body" style={{ fontSize: '1.15rem', fontWeight: 500 }}>
          <p><strong>Adı Soyadı:</strong> {customer.name}</p>
          <p><strong>Telefon:</strong> {customer.phone}</p>
          <p><strong>Adres:</strong> {customer.address}</p>
          <p style={{ fontSize: '2rem', fontWeight: 'bold', marginTop: 20 }}><strong>Güncel Bakiye:</strong> ₺{Number(balance).toLocaleString('tr-TR', { minimumFractionDigits: 2 })}</p>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-6">
          <button className="btn btn-info w-100 mb-3" onClick={() => setShowInvoiceAddModal(true)}>Yeni İrsaliye Kes</button>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h3>İrsaliyeler</h3>
            <div>
              <button className="btn btn-success btn-sm me-2" onClick={handleExportExcel}>Excele Aktar</button>
              {/* <button className="btn btn-danger btn-sm me-2" onClick={handleExportPDF}>PDF'e Aktar</button> */}
              <button className="btn btn-secondary btn-sm me-2" onClick={handleOpenAllInvoicesInNewTab}>Tüm İrsaliyeleri Yeni Sekmede Aç</button>
            </div>
          </div>
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Açıklamaya göre ara..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>İrsaliye No</th>
                <th>Tarih</th>
                <th>Ürün</th>
                <th>Açıklama</th>
                <th>Tutar</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredInvoices.length === 0 ? (
                <tr><td colSpan="6">Henüz irsaliye yok.</td></tr>
              ) : (
                filteredInvoices.map(inv => (
                  <tr key={inv.id}>
                    <td>{inv.invoice_number}</td>
                    <td>{inv.date}</td>
                    <td>
                      {inv.items && inv.items.map(item => item.product_name).join(', ')}
                    </td>
                    <td>
                      {inv.items && inv.items.map(item => item.description).filter(desc => desc).join(', ')}
                    </td>
                    <td>{Number(inv.total_price).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
                    <td>
                      <button className="btn btn-info btn-sm me-2" onClick={() => navigate(`/invoice-print/${inv.id}`)}>Yazdır</button>
                      <button className="btn btn-warning btn-sm me-2" onClick={() => {
                        setEditingInvoiceData(inv);
                        setShowInvoiceEditModal(true);
                      }}>Düzenle</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteInvoice(inv.id)}>Sil</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {totalInvoicePages > 1 && (
            <nav aria-label="Invoice pagination">
              <ul className="pagination justify-content-center">
                <li className={`page-item ${currentInvoicePage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentInvoicePage(prev => prev - 1)}>Önceki</button>
                </li>
                {[...Array(totalInvoicePages).keys()].map(num => (
                  <li key={num} className={`page-item ${currentInvoicePage === num + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentInvoicePage(num + 1)}>{num + 1}</button>
                  </li>
                ))}
                <li className={`page-item ${currentInvoicePage === totalInvoicePages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentInvoicePage(prev => prev + 1)}>Sonraki</button>
                </li>
              </ul>
            </nav>
          )}
        </div>

        <div className="col-md-6">
          <button className="btn btn-warning w-100 mb-3" onClick={() => setShowPaymentAddModal(true)}>Yeni Ödeme Al</button>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h3>Ödemeler</h3>
            <div>
              <button className="btn btn-success btn-sm me-2" onClick={handleExportPaymentsExcel}>Excele Aktar</button>
              <button className="btn btn-secondary btn-sm" onClick={handleOpenAllPaymentsInNewTab}>Tüm Ödemeleri Yeni Sekmede Aç</button>
            </div>
          </div>
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Tarih</th>
                <th>Tutar</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 ? (
                <tr><td colSpan="3">Henüz ödeme yok.</td></tr>
              ) : (
                payments.map(pay => (
                  <tr key={pay.id}>
                    <td>{pay.date}</td>
                    <td>{Number(pay.amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' })}</td>
                    <td>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeletePayment(pay.id)}>Sil</button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {totalPaymentPages > 1 && (
            <nav aria-label="Payment pagination">
              <ul className="pagination justify-content-center">
                <li className={`page-item ${currentPaymentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPaymentPage(prev => prev - 1)}>Önceki</button>
                </li>
                {[...Array(totalPaymentPages).keys()].map(num => (
                  <li key={num} className={`page-item ${currentPaymentPage === num + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPaymentPage(num + 1)}>{num + 1}</button>
                  </li>
                ))}
                <li className={`page-item ${currentPaymentPage === totalPaymentPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPaymentPage(prev => prev + 1)}>Sonraki</button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>

      {/* İrsaliye Ekle Modal */}
      {showInvoiceAddModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Yeni İrsaliye Kes (Müşteri: {customer.name})</h5>
                  <button type="button" className="btn-close" onClick={() => setShowInvoiceAddModal(false)}></button>
                </div>
                <div className="modal-body">
                  <InvoiceAdd onInvoiceAdded={handleRefreshData} preselectedCustomerId={id} userId={user.id} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Ödeme Ekle Modal */}
      {showPaymentAddModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Yeni Ödeme Al (Müşteri: {customer.name})</h5>
                  <button type="button" className="btn-close" onClick={() => setShowPaymentAddModal(false)}></button>
                </div>
                <div className="modal-body">
                  <PaymentAdd onPaymentAdded={handleRefreshData} preselectedCustomerId={id} userId={user.id} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* İrsaliye Düzenle Modal */}
      {showInvoiceEditModal && editingInvoiceData && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">İrsaliye Düzenle (Müşteri: {customer.name})</h5>
                  <button type="button" className="btn-close" onClick={() => setShowInvoiceEditModal(false)}></button>
                </div>
                <div className="modal-body">
                  <InvoiceAdd
                    onInvoiceAdded={() => { handleRefreshData(); setShowInvoiceEditModal(false); }}
                    userId={user.id}
                    preselectedCustomerId={id}
                    editMode={true}
                    initialData={editingInvoiceData}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default CustomerDetailPage;
